import { get } from 'lodash';

export default {
  defaultSortField: 'name',
  defaultSortOrder: 'asc',
  rearrangeCols: false,
  stickeyHeaders: true,
  isCardView: true,
  permissionModule: '',
  toolBar: {
    hideSearchBar: true, // by default let the search bar be available for the table
    buttons: [{
      event: 'addNew',
      icon: 'icon-addnew',
      tooltip: 'Add',
      isLine: true,
      acl: {},
    }, {
      event: 'excelImport',
      icon: 'icon-importexcel',
      tooltip: 'Import From Excel',
      isLine: true,
      acl: {},
    }],
  },
  fields: [
    {
      name: 'field-generic-input',
      sortField: 'text',
      width: '400px',
      alwaysVisible: true,
      title: 'Task',
      prop: 'text',
      id: 'text',
      searchable: true,
      sticky: true,
      inputProps: {
        type: 'text',
        textArea: true,
      },
    },
    {
      name: 'assignee',
      sortField: 'assignedTo.user.name',
      width: '296px',
      title: 'Assignee',
      id: 'assignedTo.user.name',
      defaultVisible: true,
      dataClass: 'overflow-visible',
    },
    {
      name: 'taskId',
      width: '400px',
      alwaysVisible: true,
      title: 'Task ID',
      id: 'taskId',
      isDisabled: true,
      prop: 'taskId',
    },
    {
      name: 'field-date', // todo: once GenericDate is implemented
      sortField: 'dueDate',
      prop: 'dueDate',
      width: '152px',
      id: 'dueDate',
      type: 'generic-date',
      title: 'Due Date',
      defaultVisible: true,
      inputProps: {
        kind: 'dueDate',
        disableEdit: false,
      },
      dataClass: 'overflow-visible',
    },
    {
      name: 'private',
      width: '64px',
      title: 'Private',
      id: 'private',
    },
    {
      name: 'status',
      sortField: 'status',
      width: '196px',
      title: 'Status',
      dataClass: 'overflow-visible',
      id: 'status',
      defaultVisible: true,
    },
    {
      name: 'type',
      sortField: 'type',
      width: '160px',
      title: 'Type',
      id: 'type',
      defaultVisible: true,
      dataClass: 'overflow-visible',
    },
    {
      name: 'checklist-docs', // todo: integrate item checklist component
      width: '64px',
      title: 'Docs',
      id: 'files',
      for: 'Task',
    },
    {
      name: 'taskSource',
      width: '296px',
      title: 'Source',
    },
    {
      title: 'Actions',
      name: 'field-card-edit-action',
      permissionModule: 'orderChecklist',
      alwaysVisible: true,
      id: 'action',
      width: '112px',
      // sticky: true,
      // thAttrs: () => ({ class: 'action-sticky' }),
      // tdClass: 'action-sticky',
    },
  ],
};
